import { useNavigate } from 'react-router-dom';
import { Spin, Button } from '@bancobarigui/barihaus';
import {
  UnorderedListOutlined,
  PlusOutlined,
} from '@ant-design/icons';

import {
  DashboardCard,
  DashboardFilters,
  PendingItemsList,
} from '@/pages/Dashboard/components';
import { useDashboard } from '@/pages/Dashboard/useDashboard';
import { ElementGuard } from '@/components/PermissionGuard';
import { UserPermissions } from '@/shared/enums/UserPermissions';
import { ServiceCheck, FeatureAlert } from '@/shared/components';
import { ProtectedRouteContainer } from '@/components/ProtectedRouteContainer';
import { PageHeader } from '@/components/PageHeader';

// Body interno que só carrega quando o serviço está online (useDashboard faz API calls)
function DashboardBody() {
  const {
    filters,
    cards,
    pendingItems,
    isLoading,
    handleFilterChange,
    handleClearFilters,
    handleApplyFilters,
    handleCardClick,
    handlePendingItemClick,
  } = useDashboard();

  return (
    <>
      {/* Filtros */}
      <DashboardFilters
        filters={filters}
        isLoading={isLoading}
        onFilterChange={handleFilterChange}
        onClear={handleClearFilters}
        onApply={handleApplyFilters}
      />

      {/* Conteúdo principal */}
      <Spin spinning={isLoading} tip="Carregando dados...">
        {/* Grid de Cards de Indicadores */}
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: `repeat(${cards.length}, 1fr)`,
            gap: '32px',
            marginBottom: '24px',
          }}
        >
          {cards.map((card) => (
            <DashboardCard
              key={card.id}
              card={card}
              onClick={handleCardClick}
            />
          ))}
        </div>

        {/* Seção de Pendências */}
        <div className="mt-8">
          <div className="flex items-center gap-2 mb-4">
            <h3 className="text-lg font-medium text-gray-800 m-0">
              Acompanhamento de Pendências
            </h3>
            <span className="text-sm text-gray-500">
              Itens que requerem atenção
            </span>
          </div>

          <PendingItemsList
            items={pendingItems}
            onItemClick={handlePendingItemClick}
          />
        </div>
      </Spin>
    </>
  );
}

export function DashboardSection() {
  const navigate = useNavigate();

  const handleViewAllInspections = () => navigate('/dashboard/all_inspections');
  const handleNewInspection = () => navigate('/request-inspection');

  return (
    <ProtectedRouteContainer
      pageHeader={
        <PageHeader
          title="Dashboard"
          subtitle="Visão geral das inspeções"
          actions={
            <>
              <Button
                icon={<UnorderedListOutlined />}
                onClick={handleViewAllInspections}
                style={{ borderColor: '#101010', color: '#101010', backgroundColor: 'transparent', boxShadow: 'none' }}
              >
                Ver todas
              </Button>
              <ElementGuard permissions={[UserPermissions.inspections_create_bank]}>
                <Button
                  icon={<PlusOutlined />}
                  onClick={handleNewInspection}
                  className="!border-0 !bg-[#0090ff] hover:!bg-[#0077d5] !text-white !shadow-none"
                >
                  Nova Inspeção
                </Button>
              </ElementGuard>
            </>
          }
        />
      }
    >
      <div style={{ overflow: 'hidden' }}>
        <FeatureAlert services={['inspection', 'user']} />
        <ServiceCheck services={['inspection']} featureName="Dashboard">
          <DashboardBody />
        </ServiceCheck>
      </div>
    </ProtectedRouteContainer>
  );
}
